/**
 * 評価データマッパー用ユーティリティ
 */

import { Timestamp } from "firebase/firestore";

/**
 * タイムスタンプを安全に取得
 *
 * Firestoreのタイムスタンプは以下の形式で取得される可能性がある:
 * - Timestamp型（通常のFirestore SDK）
 * - { seconds: number } オブジェクト
 * - { _seconds: number } オブジェクト（シリアライズ済み）
 * - ISO 8601文字列 ("2025-11-10T08:11:27.874Z")
 * - null/undefined
 */
export function getTimestampSeconds(timestamp: unknown): number {
  if (!timestamp) {
    return Math.floor(Date.now() / 1000);
  }
  // Firestore Timestamp型
  if (timestamp instanceof Timestamp) {
    return timestamp.seconds;
  }
  // オブジェクトでsecondsプロパティがある場合
  if (typeof timestamp === "object" && "seconds" in timestamp) {
    return (timestamp as { seconds: number }).seconds;
  }
  // _secondsプロパティがある場合（シリアライズ済み）
  if (typeof timestamp === "object" && "_seconds" in timestamp) {
    return (timestamp as { _seconds: number })._seconds;
  }
  // ISO 8601文字列の場合
  if (typeof timestamp === "string") {
    const date = new Date(timestamp);
    if (!isNaN(date.getTime())) {
      return Math.floor(date.getTime() / 1000);
    }
  }
  return Math.floor(Date.now() / 1000);
}
